import React from 'react';

import { log } from '../../../services/utils';

import AuthForm from '../AuthForm';
import ResetPassForm from './ResetPassForm';

const ResetPass = () => {
	return (
		<div id="reset-pass">
			{ log( 'resetPass' ) }
			<AuthForm>
				<ResetPassForm />
			</AuthForm>
		</div>
	);
};

export default ResetPass;
